// removeOrderBy — VQE-Edit edit-action: drop one ORDER BY entry by 0-based
// list index via SR-Edit's `remove-order-by` op. When the list shrinks to
// zero, SR-Edit also drops the `ORDER BY` keyword. This module just validates
// the index against an optional structure and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove ORDER BY.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveOrderByOptions = {
  /**
   * Optional structure used for index-bounds validation. Surfaces a friendlier
   * error than SR-Edit's silent drop when the list is empty or the index is
   * out of range.
   */
  readonly structure?: QueryStructure;
};

export async function removeOrderBy(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveOrderByOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`removeOrderBy: index must be a non-negative integer (got ${index})`);
  }
  if (options.structure) {
    const items = options.structure.orderBy ?? [];
    if (items.length === 0) {
      throw new Error('removeOrderBy: ORDER BY list is empty');
    }
    if (index >= items.length) {
      throw new Error(
        `removeOrderBy: index ${index} out of range (ORDER BY list has ${items.length} item(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-order-by', index }, ctx);
}
